var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _polygon, _path69, _path70, _path71, _polygon2, _polygon3, _polygon4, _path72, _polygon5, _path73, _path74, _path75, _path76, _polygon6, _path77, _path78, _path79, _polygon7, _polygon8, _polygon9, _path80, _polygon10, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _polygon20, _polygon21, _polygon22, _polygon23, _polygon24, _polygon25, _polygon26, _polygon27, _polygon28, _polygon29, _polygon30, _polygon31, _polygon32, _polygon33, _polygon34, _polygon35, _polygon36, _polygon37, _polygon38, _polygon39, _polygon40, _polygon41, _polygon42, _polygon43, _polygon44, _polygon45, _polygon46, _polygon47, _polygon48, _polygon49, _polygon50, _polygon51, _polygon52, _polygon53, _polygon54, _polygon55, _polygon56, _polygon57, _polygon58, _polygon59, _polygon60, _polygon61, _polygon62, _polygon63, _polygon64, _polygon65, _polygon66, _polygon67, _polygon68, _polygon69, _polygon70, _polygon71, _polygon72, _polygon73, _polygon74, _polygon75, _polygon76, _polygon77, _polygon78, _polygon79, _polygon80, _polygon81, _polygon82, _polygon83, _polygon84, _polygon85, _polygon86, _polygon87, _polygon88, _polygon89, _polygon90, _polygon91, _polygon92, _polygon93, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _polygon94, _polygon95, _polygon96, _polygon97, _polygon98, _polygon99, _polygon100, _polygon101, _polygon102, _polygon103, _polygon104, _polygon105, _polygon106, _polygon107, _polygon108, _polygon109, _polygon110, _polygon111, _polygon112, _polygon113, _polygon114, _polygon115, _polygon116, _polygon117, _polygon118, _polygon119;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg404(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 735.09 403.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#d8cc4c;}.b{fill:url(#a);}.c{fill:#f2e455;}.d{fill:url(#b);}.e,.r,.w{fill:#0036B5;}.e,.n{opacity:0.43;}.f{fill:url(#c);}.g{fill:url(#d);}.h{fill:#000;}.i{fill:url(#e);}.j,.n{fill:#736c28;}.k{fill:#ea2253;}.l{fill:url(#f);}.m{fill:url(#g);}.o{fill:url(#h);}.p{fill:url(#i);}.q{fill:url(#j);}.r{opacity:0.85;}.s{fill:url(#k);}.t{fill:#227;}.u{fill:url(#l);}.v{fill:#fff059;}.x,.y{fill:#9faffc;}.x{opacity:0.2;}.y{opacity:0;}.z{fill:url(#m);}.aa{fill:url(#n);}.ab{fill:url(#o);}.ac{fill:url(#p);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 365.93,
    y1: 303.42,
    x2: 187.55,
    y2: 303.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#fff059"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#f8ea57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#e5d850"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#c7bb46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#b2a83f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 738.42,
    y1: 48.01,
    x2: 549.58,
    y2: 48.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#fff059"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#f8ea57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#e5d850"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#c7bb46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#b2a83f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 188.44,
    y1: 255.57,
    x2: 241.67,
    y2: 255.57,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 648.13,
    y1: 131.15,
    x2: 710.9,
    y2: 131.15,
    gradientTransform: "translate(-2.52)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 701.01,
    y1: 72.36,
    x2: 654.27,
    y2: 72.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#fff059"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#f8ea57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#e5d850"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#c7bb46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#b2a83f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 434.32,
    y1: 242.13,
    x2: 283.72,
    y2: 242.13,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 729.73,
    y1: 355.18,
    x2: 647.95,
    y2: 355.18,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 244.76,
    y1: 329.43,
    x2: 297.89,
    y2: 329.43,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 244.76,
    y1: 306.59,
    x2: 297.89,
    y2: 306.59,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 670.3,
    y1: 260.61,
    x2: 721.85,
    y2: 260.61,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 2.01,
    y1: 318.97,
    x2: 27.11,
    y2: 318.97,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 459.7,
    y1: 54.64,
    x2: 540.04,
    y2: 275.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#fff059"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#f8ea57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#e5d850"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#c7bb46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#b2a83f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 489.49,
    y1: 383.63,
    x2: 539.98,
    y2: 383.63,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 489.49,
    y1: 361.93,
    x2: 539.98,
    y2: 361.93,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 489.49,
    y1: 340.17,
    x2: 539.98,
    y2: 340.17,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 489.49,
    y1: 318.26,
    x2: 539.98,
    y2: 318.26,
    xlinkHref: "#b"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M285,368.05,351,329.89a5.63,5.63,0,0,0,0-9.73l-66.3-38.37a17.68,17.68,0,0,0-17.71,0l-67.12,38.85a5.42,5.42,0,0,0,0,9.38l65.72,38A19.41,19.41,0,0,0,285,368.05Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M351,325.28,284.58,287a17.73,17.73,0,0,0-17.74,0l-67.25,38.76a5.36,5.36,0,0,0-2,1.94,5.39,5.39,0,0,1,2-7.42l67.25-38.77a17.78,17.78,0,0,1,17.74,0L351,319.8a5.61,5.61,0,0,1,2.1,7.6A5.61,5.61,0,0,0,351,325.28Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M654.77,116.7l70.07-40.56a6,6,0,0,0,0-10.34L654.39,25a18.78,18.78,0,0,0-18.82,0L564.23,66.31a5.75,5.75,0,0,0,0,10l69.84,40.43A20.69,20.69,0,0,0,654.77,116.7Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M724.89,71.24,654.31,30.55a18.9,18.9,0,0,0-18.86,0L564,71.75a5.63,5.63,0,0,0-2.08,2.06A5.74,5.74,0,0,1,564,65.92l71.46-41.19a18.86,18.86,0,0,1,18.86,0l70.58,40.68a6,6,0,0,1,2.23,8.08A5.94,5.94,0,0,0,724.89,71.24Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M262.34,251.23,234,234.77a9,9,0,0,0-9,0l-36.25,21,31.87,19h13.7l28.11-17.35A3.57,3.57,0,0,0,262.34,251.23Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M254.41,236.3V254a2.56,2.56,0,0,1-1.28,2.23L223,273.66a8.88,8.88,0,0,1-8.89,0l-30-17.38a2.43,2.43,0,0,1-1.22-2.28h-.19V236.3Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M223,255.76l30.11-17.43a2.56,2.56,0,0,0,0-4.44l-30.28-17.53a8.07,8.07,0,0,0-8.09,0l-30.65,17.75a2.47,2.47,0,0,0,0,4.28l30,17.37A8.9,8.9,0,0,0,223,255.76Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M708.38,79.43H645.61v85.19a2.24,2.24,0,0,0,1.12,1.95l26.36,15.25a7.75,7.75,0,0,0,7.79,0l26.27-15.2a2.15,2.15,0,0,0,1.07-2h.16Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M673.12,96.76,646.77,81.5a2.24,2.24,0,0,1,0-3.89l26.5-15.34a7.1,7.1,0,0,1,7.08,0l26.83,15.54a2.16,2.16,0,0,1,0,3.74L680.91,96.76A7.8,7.8,0,0,1,673.12,96.76Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M674.41,91l-19-11a1.61,1.61,0,0,1,0-2.8l19.1-11.06a5.1,5.1,0,0,1,5.1,0L699,77.33a1.56,1.56,0,0,1,0,2.7L680,91A5.62,5.62,0,0,1,674.41,91Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M655.39,78.66l19.14-11a5.12,5.12,0,0,1,5.11,0L699,78.8a1.53,1.53,0,0,1,.57.56,1.56,1.56,0,0,0-.57-2.14L679.64,66.05a5.12,5.12,0,0,0-5.11,0l-19.14,11a1.61,1.61,0,0,0-.6,2.19A1.59,1.59,0,0,1,655.39,78.66Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M670.13,161.45l-15.71-9.09a3.93,3.93,0,0,1-1.95-3.39V96.66l-.2-.12A1.5,1.5,0,0,0,650,97.85v52.83a3.91,3.91,0,0,0,2,3.38l15.7,9.09a2.34,2.34,0,0,0,3.42-1.41A2.27,2.27,0,0,1,670.13,161.45Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M671.17,110.28a4.85,4.85,0,0,0-2.42-4.2l-16.28-9.42V149a3.93,3.93,0,0,0,1.95,3.39l15.71,9.09a2.27,2.27,0,0,0,1,.29,2.49,2.49,0,0,0,.08-.61Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M656.83,147.73a2.46,2.46,0,0,1-1-2V104.15c0-.75.46-1.1,1-.77a2.47,2.47,0,0,1,1,2V147C657.85,147.7,657.39,148.05,656.83,147.73Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M661,150a2.41,2.41,0,0,1-1-1.91V120.78c0-.73.45-1.07,1-.75a2.4,2.4,0,0,1,1,1.91v27.33C662,150,661.56,150.35,661,150Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M665.3,111.52c-.55-.32-1,0-1,.76v38.46a2.41,2.41,0,0,0,1,1.91c.55.31,1,0,1-.76V113.43A2.41,2.41,0,0,0,665.3,111.52Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M348.61,302.15l-61.23-35.44a5.22,5.22,0,0,1,0-9L348.94,222a16.44,16.44,0,0,1,16.45,0l62.33,36.08a5,5,0,0,1,0,8.71l-61,35.32A18,18,0,0,1,348.61,302.15Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M287.33,262.43,349,226.88a16.5,16.5,0,0,1,16.48,0l62.44,36a5,5,0,0,1,1.82,1.79,5,5,0,0,0-1.82-6.89l-62.44-36a16.55,16.55,0,0,0-16.48,0l-61.68,35.56a5.2,5.2,0,0,0-1.94,7.05A5.13,5.13,0,0,1,287.33,262.43Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M683.19,387.77l-33.25-19.24a2.83,2.83,0,0,1,0-4.91l33.43-19.35a8.91,8.91,0,0,1,8.93,0l33.85,19.59a2.73,2.73,0,0,1,0,4.73L693,387.77A9.79,9.79,0,0,1,683.19,387.77Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M649.91,366.2l33.5-19.3a8.93,8.93,0,0,1,8.94,0l33.92,19.55a2.68,2.68,0,0,1,1,1,2.72,2.72,0,0,0-1-3.74l-33.92-19.55a8.93,8.93,0,0,0-8.94,0l-33.5,19.31a2.82,2.82,0,0,0-1,3.83A2.76,2.76,0,0,1,649.91,366.2Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M319.39,325.14l-28-16.31a8.91,8.91,0,0,0-9,0l-35.9,20.77,31.56,18.78h13.57l27.83-17.19A3.52,3.52,0,0,0,319.39,325.14Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M311.53,310.34v17.54a2.52,2.52,0,0,1-1.27,2.2l-29.82,17.26a8.78,8.78,0,0,1-8.81,0l-29.73-17.2a2.42,2.42,0,0,1-1.21-2.26h-.18V310.34Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M280.4,329.62l29.83-17.26a2.54,2.54,0,0,0,0-4.4l-30-17.36a8,8,0,0,0-8,0l-30.36,17.57a2.45,2.45,0,0,0,0,4.24l29.72,17.21A8.78,8.78,0,0,0,280.4,329.62Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M284.11,334.56a2.53,2.53,0,0,0-1.05,2c0,.77.47,1.13,1.05.8l19.23-11.14,0-2.8Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M306.07,321.85l-2.7,1.57,0,2.8,2.73-1.58a2.52,2.52,0,0,0,1-2C307.11,321.87,306.64,321.52,306.07,321.85Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M311.53,287.5V305a2.52,2.52,0,0,1-1.27,2.2L280.44,324.5a8.78,8.78,0,0,1-8.81,0L241.9,307.3a2.42,2.42,0,0,1-1.21-2.26h-.18V287.5Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M280.4,306.78l29.83-17.26a2.54,2.54,0,0,0,0-4.4l-30-17.36a8,8,0,0,0-8,0l-30.36,17.57a2.45,2.45,0,0,0,0,4.24l29.72,17.21A8.78,8.78,0,0,0,280.4,306.78Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M284.11,311.72a2.53,2.53,0,0,0-1.05,2c0,.77.47,1.13,1.05.79l19.23-11.13,0-2.8Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M306.07,299l-2.7,1.57,0,2.8,2.73-1.58a2.52,2.52,0,0,0,1-2C307.11,299,306.64,298.68,306.07,299Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M269.86,315.15a2.67,2.67,0,0,0,1.21,2.09c.67.38,1.21.07,1.21-.69a2.67,2.67,0,0,0-1.21-2.09C270.4,314.07,269.86,314.38,269.86,315.15Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M265.61,312.69a2.67,2.67,0,0,0,1.21,2.09c.67.38,1.21.08,1.21-.69a2.67,2.67,0,0,0-1.21-2.09C266.15,311.62,265.61,311.92,265.61,312.69Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M261.36,310.23a2.67,2.67,0,0,0,1.21,2.09c.67.39,1.21.08,1.21-.69a2.67,2.67,0,0,0-1.21-2.09C261.9,309.16,261.36,309.47,261.36,310.23Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M257.11,307.77a2.67,2.67,0,0,0,1.21,2.09c.67.39,1.21.08,1.21-.69a2.67,2.67,0,0,0-1.21-2.09C257.65,306.7,257.11,307,257.11,307.77Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M252.86,305.31a2.68,2.68,0,0,0,1.21,2.09c.67.39,1.21.08,1.21-.69a2.67,2.67,0,0,0-1.21-2.09C253.41,304.24,252.86,304.55,252.86,305.31Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M248.62,302.85a2.67,2.67,0,0,0,1.2,2.09c.67.39,1.21.08,1.21-.69a2.67,2.67,0,0,0-1.21-2.09C249.16,301.78,248.62,302.09,248.62,302.85Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M244.37,300.4a2.67,2.67,0,0,0,1.2,2.08c.67.39,1.21.08,1.21-.69a2.65,2.65,0,0,0-1.21-2.08C244.91,299.32,244.37,299.63,244.37,300.4Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M269.55,336.64a2.67,2.67,0,0,0,1.21,2.09c.66.38,1.21.08,1.21-.69a2.7,2.7,0,0,0-1.21-2.09C270.09,335.57,269.55,335.87,269.55,336.64Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M265.3,334.18a2.67,2.67,0,0,0,1.21,2.09c.67.39,1.21.08,1.21-.69a2.67,2.67,0,0,0-1.21-2.09C265.84,333.11,265.3,333.42,265.3,334.18Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M261.05,331.72a2.67,2.67,0,0,0,1.21,2.09c.67.39,1.21.08,1.21-.69a2.67,2.67,0,0,0-1.21-2.09C261.59,330.65,261.05,331,261.05,331.72Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M256.8,329.26a2.67,2.67,0,0,0,1.21,2.09c.67.39,1.21.08,1.21-.69a2.67,2.67,0,0,0-1.21-2.09C257.34,328.19,256.8,328.5,256.8,329.26Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M252.55,326.8a2.65,2.65,0,0,0,1.21,2.09c.67.39,1.21.08,1.21-.69a2.67,2.67,0,0,0-1.21-2.09C253.09,325.73,252.55,326,252.55,326.8Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M248.31,324.34a2.67,2.67,0,0,0,1.2,2.09c.67.39,1.21.08,1.21-.69a2.65,2.65,0,0,0-1.21-2.08C248.85,323.27,248.31,323.58,248.31,324.34Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M244.06,321.89a2.67,2.67,0,0,0,1.2,2.08c.67.39,1.21.08,1.21-.69a2.65,2.65,0,0,0-1.21-2.08C244.6,320.81,244.06,321.12,244.06,321.89Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M735.09,242.08v17a2.43,2.43,0,0,1-1.23,2.13L704.92,278a8.54,8.54,0,0,1-8.55,0l-28.85-16.69a2.36,2.36,0,0,1-1.17-2.19h-.18v-17Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M704.88,260.79,733.82,244a2.47,2.47,0,0,0,0-4.27l-29.09-16.85a7.78,7.78,0,0,0-7.78,0L667.49,240a2.37,2.37,0,0,0,0,4.11l28.85,16.7A8.52,8.52,0,0,0,704.88,260.79Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M708.48,265.58a2.46,2.46,0,0,0-1,1.94c0,.75.46,1.09,1,.77l18.66-10.8,0-2.72Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M694.35,267.6a2.6,2.6,0,0,0,1.17,2c.65.38,1.18.08,1.18-.66a2.58,2.58,0,0,0-1.18-2C694.88,266.56,694.35,266.86,694.35,267.6Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M690.23,265.21a2.59,2.59,0,0,0,1.17,2c.65.37,1.17.07,1.17-.67a2.59,2.59,0,0,0-1.17-2C690.75,264.17,690.23,264.47,690.23,265.21Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M686.11,262.83a2.57,2.57,0,0,0,1.17,2c.64.38,1.17.08,1.17-.67a2.6,2.6,0,0,0-1.17-2C686.63,261.78,686.11,262.08,686.11,262.83Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M682,260.44a2.63,2.63,0,0,0,1.17,2c.65.37,1.18.07,1.18-.67a2.6,2.6,0,0,0-1.18-2C682.51,259.4,682,259.7,682,260.44Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M677.86,258.05a2.59,2.59,0,0,0,1.17,2c.65.37,1.17.07,1.17-.67a2.6,2.6,0,0,0-1.17-2C678.38,257,677.86,257.31,677.86,258.05Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M673.74,255.67a2.57,2.57,0,0,0,1.17,2c.65.38,1.17.08,1.17-.67a2.57,2.57,0,0,0-1.17-2C674.26,254.62,673.74,254.92,673.74,255.67Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M669.61,253.28a2.6,2.6,0,0,0,1.18,2c.64.37,1.17.07,1.17-.67a2.61,2.61,0,0,0-1.17-2C670.14,252.24,669.61,252.54,669.61,253.28Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M37.26,316.94,24,309.24a4.19,4.19,0,0,0-4.23,0l-17,9.82,14.91,8.86h6.41l13.15-8.12A1.66,1.66,0,0,0,37.26,316.94Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M33.55,310v8.29a1.18,1.18,0,0,1-.6,1l-14.09,8.16a4.18,4.18,0,0,1-4.16,0l-14-8.13a1.11,1.11,0,0,1-.57-1.06C0,318.24,0,310,0,310Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M18.85,319.06l14.09-8.16a1.21,1.21,0,0,0,0-2.08l-14.17-8.19a3.76,3.76,0,0,0-3.78,0L.64,308.93a1.15,1.15,0,0,0,0,2l14.05,8.13A4.18,4.18,0,0,0,18.85,319.06Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M20.6,321.39a1.22,1.22,0,0,0-.5.95c0,.36.23.53.5.37l9.08-5.26v-1.32Z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M13.72,322.37a1.26,1.26,0,0,0,.57,1c.32.18.57,0,.57-.33a1.24,1.24,0,0,0-.57-1C14,321.87,13.72,322,13.72,322.37Z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M11.71,321.21a1.26,1.26,0,0,0,.57,1c.32.18.57,0,.57-.33a1.24,1.24,0,0,0-.57-1C12,320.7,11.71,320.85,11.71,321.21Z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M9.71,320.05a1.27,1.27,0,0,0,.57,1c.31.18.57,0,.57-.33a1.26,1.26,0,0,0-.57-1C10,319.54,9.71,319.69,9.71,320.05Z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M7.7,318.89a1.27,1.27,0,0,0,.57,1c.31.18.57,0,.57-.33a1.3,1.3,0,0,0-.57-1C8,318.38,7.7,318.53,7.7,318.89Z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M5.69,317.73a1.26,1.26,0,0,0,.57,1c.32.19.57,0,.57-.32a1.25,1.25,0,0,0-.57-1C6,317.22,5.69,317.37,5.69,317.73Z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M3.68,316.57a1.26,1.26,0,0,0,.57,1c.32.18.57,0,.57-.32a1.24,1.24,0,0,0-.57-1C3.94,316.06,3.68,316.2,3.68,316.57Z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M1.68,315.4a1.24,1.24,0,0,0,.57,1c.31.18.57,0,.57-.33a1.26,1.26,0,0,0-.57-1C1.93,314.9,1.68,315,1.68,315.4Z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M320.92,276.27c-11.77-6.81-11.83-17.86-.14-24.62s30.78-6.73,42.54.07,11.83,17.86.14,24.63S332.68,283.08,320.92,276.27Zm41-23.74c-11-6.36-28.81-6.39-39.73-.07s-10.87,16.64.12,23,28.82,6.39,39.74.07S372.91,258.89,361.92,252.53Z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M329.1,271.53c-7.23-4.18-7.27-11-.09-15.12s18.91-4.13,26.13,0,7.26,11,.08,15.12S336.32,275.72,329.1,271.53Zm25.34-14.67c-6.84-4-17.93-4-24.72,0s-6.76,10.35.08,14.31,17.93,4,24.72,0S361.28,260.82,354.44,256.86Z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M365.13,274.57a5.42,5.42,0,0,0-4.93,0l-.13.09c-10,5.62-26.06,5.55-36-.2s-10.07-15.21-.11-21,25.9-5.73,35.94-.09a1.89,1.89,0,0,0,.22.12,5.5,5.5,0,0,0,4.79-.06c1.29-.75,1.34-1.94.17-2.73l-.18-.13-.28-.13c-12.77-7.11-33.08-7.07-45.58.17-12.66,7.33-12.59,19.28.14,26.65s33,7.4,45.64.31l.34-.16C366.51,276.64,366.5,275.36,365.13,274.57Z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M356.3,255.79c-7.82-4.53-20.48-4.58-28.31-.14-.88.53-.88,1.31,0,1.8a3.36,3.36,0,0,0,3,0c6.25-3.52,16.16-3.47,22.29.08s6.22,9.39.07,13-16.2,3.54-22.39,0a3.36,3.36,0,0,0-3.07,0,.93.93,0,0,0,0,1.76c7.9,4.57,20.67,4.59,28.49.07S364.17,260.34,356.3,255.79Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "j",
    points: "363.51 143.46 397.81 123.53 397.81 21.25 363.51 41.17 363.51 143.46"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M324.32,97c.05-3,.15-6.54.31-10.66.23-6.15.42-9.34.55-9.57l-1.1-.65a63.13,63.13,0,0,1-7.75,12.19L300,106.72l24.29-13.78Z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M300,106.72l24.24,14S300,106.72,300,106.72Z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M363.58,177.54,379.7,187V152.83l-16.19-9.37V41.17L326.79,19.92,265.63,87.39v33.55l58.64,33.94v32.75l39.24,22.7V177.59ZM300,106.72l16.3-18.45a63.13,63.13,0,0,0,7.75-12.19l1.1.65c-.13.23-.32,3.42-.55,9.57-.16,4.12-.26,7.64-.31,10.66v23.79C324.27,120.75,300,106.72,300,106.72Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "363.51 41.17 397.81 21.25 361.1 0 326.79 19.92 363.51 41.17"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "324.32 120.75 324.32 96.96 324.32 92.94 300.03 106.72 324.27 120.73 324.32 120.75"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "379.7 152.83 414 132.91 397.81 123.53 363.51 143.46 379.7 152.83"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M379.7,187l-16.12-9.42c-.07.05-.07,32.79-.07,32.79l34.3-19.92v-14Z"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "j",
    points: "414 132.91 379.7 152.83 379.7 186.96 397.81 176.44 414 167.04 414 132.91"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M443.3,215.86q3.12,12.57,10.46,16.82t10.51-5c1.65-5,2.63-14.16,3-27.28l-24.08,14.72C443.19,215.34,443.24,215.62,443.3,215.86Z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M467.22,200.37c.07-3.14.12-6.44.12-10.05q0-28.11-3.12-41.2t-10.46-17.34q-7.35-4.25-10.46,4.82t-3.12,38c0,18.59,1,32.05,3,40.49Z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M534.17,116.45A102.94,102.94,0,0,0,516.9,89.73a92,92,0,0,0-22.42-18.17c-15.32-8.87-27.25-10.62-35.85-5.39l-.08-.07L419.63,88.63l.28.17c8.41-3.86,19.67-1.79,33.85,6.42a92.15,92.15,0,0,1,22.37,18.11,103,103,0,0,1,17.31,26.78q13.44,29.7,13.43,73.09,0,44.9-13.07,58.21a20.35,20.35,0,0,1-5.34,3.81l.14.1L530.52,251a24.48,24.48,0,0,0,4-3.21q13.07-13.31,13.08-58.21Q547.6,146.16,534.17,116.45Z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M506.87,213.2q0-43.39-13.43-73.09a103,103,0,0,0-17.31-26.78,92.15,92.15,0,0,0-22.37-18.11C439.58,87,428.32,84.94,419.91,88.8a20.45,20.45,0,0,0-6.18,4.3q-13.08,13.5-13.08,58.62,0,43,13.38,72.6t39.73,44.81c14.67,8.48,26.2,10.44,34.7,6.09a20.35,20.35,0,0,0,5.34-3.81Q506.87,258.09,506.87,213.2ZM443.3,136.6q3.12-9.07,10.46-4.82t10.46,17.34q3.12,13.08,3.12,41.2c0,3.61,0,6.91-.12,10.05-.32,13.12-1.3,22.26-3,27.28q-3.06,9.33-10.51,5T443.3,215.86c-.06-.24-.11-.52-.16-.77-2-8.44-3-21.9-3-40.49Q440.18,145.68,443.3,136.6Z"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "j",
    points: "620.1 286.63 654.4 266.71 654.4 164.42 620.1 184.34 620.1 286.63"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M580.91,240.14c.05-3,.15-6.54.31-10.67a94.12,94.12,0,0,1,.56-9.57l-1.11-.64a63.35,63.35,0,0,1-7.75,12.18l-16.3,18.45,24.29-13.77Z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M556.62,249.89l24.25,14S556.62,249.89,556.62,249.89Z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M620.18,320.72l16.11,9.42V296l-16.19-9.37V184.34L583.38,163.1l-61.15,67.47v33.55l58.64,33.94V330.8l39.23,22.71V320.76Zm-63.56-70.83,16.3-18.45a63.35,63.35,0,0,0,7.75-12.18l1.11.64a94.12,94.12,0,0,0-.56,9.57c-.16,4.13-.26,7.65-.31,10.67v23.78S556.62,249.89,556.62,249.89Z"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "620.1 184.34 654.4 164.42 617.69 143.18 583.38 163.1 620.1 184.34"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "580.91 263.93 580.91 240.14 580.91 236.12 556.62 249.9 580.87 263.9 580.91 263.93"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "636.29 296 670.6 276.08 654.4 266.71 620.1 286.63 636.29 296"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M636.29,330.14l-16.11-9.42c-.08,0-.08,32.79-.08,32.79l34.3-19.92v-14Z"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "j",
    points: "670.6 276.08 636.29 296 636.29 330.14 654.4 319.62 670.6 310.22 670.6 276.08"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M296.77,208.08a3.77,3.77,0,0,1-1.87-.5l-58.53-33.66a6.24,6.24,0,0,1-3-6.84l9.29-38.82a4.65,4.65,0,0,1,6.73-2.93l59.87,32.49a5,5,0,0,1,2.46,5.8l-11.38,41.69a3.72,3.72,0,0,1-2.19,2.48A3.59,3.59,0,0,1,296.77,208.08Zm-52.53-79.43L235,167.45a4.66,4.66,0,0,0,2.19,5.09l58.54,33.66a2.14,2.14,0,0,0,1.91.13,2.17,2.17,0,0,0,1.26-1.43l11.39-41.7a3.48,3.48,0,0,0-1.7-4l-59.87-32.49a3.08,3.08,0,0,0-4.44,1.93Z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M258.92,138.92a.46.46,0,0,1-.17-.5c.05-.19.2-.28.35-.2a.47.47,0,0,1,.17.5C259.22,138.92,259.07,139,258.92,138.92Z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M258.47,140.75a.47.47,0,0,1-.17-.5c.05-.2.2-.29.35-.2a.46.46,0,0,1,.17.5C258.77,140.74,258.62,140.83,258.47,140.75Z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M258,142.57a.46.46,0,0,1-.17-.5c0-.19.2-.28.35-.2a.47.47,0,0,1,.17.5C258.32,142.57,258.17,142.66,258,142.57Z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M257.57,144.4a.48.48,0,0,1-.17-.5c.05-.2.2-.29.35-.21a.48.48,0,0,1,.17.5C257.87,144.39,257.72,144.48,257.57,144.4Z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M257.13,146.22a.46.46,0,0,1-.18-.5c.05-.19.21-.28.35-.2a.46.46,0,0,1,.17.5C257.42,146.21,257.27,146.3,257.13,146.22Z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M256.68,148a.47.47,0,0,1-.18-.5c.05-.19.21-.28.35-.2a.47.47,0,0,1,.17.5C257,148,256.82,148.13,256.68,148Z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M256.23,149.87a.48.48,0,0,1-.18-.5c.05-.2.21-.29.35-.2a.46.46,0,0,1,.17.5C256.52,149.86,256.37,150,256.23,149.87Z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M255.78,151.69a.47.47,0,0,1-.18-.5c.05-.19.21-.28.35-.2a.47.47,0,0,1,.17.5C256.07,151.68,255.92,151.78,255.78,151.69Z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M255.33,153.52a.46.46,0,0,1-.17-.5c0-.2.2-.29.34-.21a.48.48,0,0,1,.17.5C255.63,153.51,255.47,153.6,255.33,153.52Z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M254.88,155.34a.45.45,0,0,1-.17-.5c0-.19.2-.28.34-.2a.46.46,0,0,1,.17.5C255.18,155.33,255,155.42,254.88,155.34Z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M254.41,157.25a.47.47,0,0,1-.18-.5c.05-.19.21-.28.35-.2a.47.47,0,0,1,.17.5C254.7,157.25,254.55,157.34,254.41,157.25Z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M254,159.08a.48.48,0,0,1-.18-.5c.05-.2.21-.29.35-.2a.46.46,0,0,1,.17.5C254.26,159.07,254.1,159.16,254,159.08Z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M253.51,160.9a.45.45,0,0,1-.17-.5c0-.19.2-.28.34-.2a.47.47,0,0,1,.17.5C253.81,160.89,253.65,161,253.51,160.9Z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M253.06,162.73a.48.48,0,0,1-.17-.5c0-.2.2-.29.34-.21a.48.48,0,0,1,.17.5C253.36,162.72,253.2,162.81,253.06,162.73Z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M252.61,164.55a.47.47,0,0,1-.17-.5c0-.19.2-.29.34-.2a.45.45,0,0,1,.17.5C252.91,164.54,252.75,164.63,252.61,164.55Z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M252.16,166.37a.46.46,0,0,1-.17-.5c0-.19.2-.28.34-.2a.48.48,0,0,1,.18.5C252.46,166.37,252.3,166.46,252.16,166.37Z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M251.71,168.2a.47.47,0,0,1-.17-.5c.05-.2.2-.29.34-.2a.47.47,0,0,1,.18.5C252,168.19,251.85,168.28,251.71,168.2Z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M251.26,170a.46.46,0,0,1-.17-.5c0-.19.2-.28.34-.2a.48.48,0,0,1,.18.5C251.56,170,251.4,170.1,251.26,170Z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M250.81,171.85a.48.48,0,0,1-.17-.5c.05-.2.2-.29.34-.21a.48.48,0,0,1,.18.5C251.11,171.84,251,171.93,250.81,171.85Z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M250.36,173.67a.47.47,0,0,1-.17-.5c.05-.2.2-.29.35-.2a.46.46,0,0,1,.17.5C250.66,173.66,250.51,173.75,250.36,173.67Z"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "v",
    points: "266.29 143.57 261.25 140.66 261.46 139.78 266.51 142.69 266.29 143.57"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "v",
    points: "265.87 145.29 260.82 142.37 261.04 141.5 266.09 144.41 265.87 145.29"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "v",
    points: "265.45 147.01 260.4 144.09 260.62 143.21 265.66 146.13 265.45 147.01"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "v",
    points: "269.12 151.09 259.98 145.81 260.19 144.93 269.34 150.22 269.12 151.09"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "v",
    points: "266.53 153.21 261.48 150.29 261.7 149.42 266.74 152.33 266.53 153.21"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "v",
    points: "266.1 154.93 261.06 152.01 261.27 151.13 266.32 154.05 266.1 154.93"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "v",
    points: "280.98 163.49 275.93 160.57 276.15 159.69 281.2 162.61 280.98 163.49"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "v",
    points: "265.68 156.65 260.63 153.73 260.85 152.85 265.9 155.77 265.68 156.65"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "v",
    points: "279.7 151.31 266.94 143.94 267.16 143.06 279.92 150.43 279.7 151.31"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "v",
    points: "276.08 151.19 266.52 145.66 266.74 144.78 276.3 150.31 276.08 151.19"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "v",
    points: "283.19 155.28 276.77 151.57 276.98 150.69 283.41 154.4 283.19 155.28"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "v",
    points: "284.83 158.21 266.1 147.38 266.31 146.5 285.05 157.33 284.83 158.21"
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "v",
    points: "282.99 159.1 270.83 152.08 271.04 151.2 283.2 158.22 282.99 159.1"
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "v",
    points: "283.57 163.06 267.18 153.59 267.39 152.71 283.79 162.18 283.57 163.06"
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    className: "v",
    points: "275.28 160.23 266.75 155.3 266.97 154.42 275.5 159.35 275.28 160.23"
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    className: "v",
    points: "279.56 164.66 266.33 157.02 266.55 156.14 279.77 163.78 279.56 164.66"
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    className: "v",
    points: "267.95 160.34 262.9 157.42 263.12 156.54 268.16 159.46 267.95 160.34"
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    className: "v",
    points: "282.19 168.56 268.61 160.71 268.83 159.83 282.41 167.68 282.19 168.56"
  })), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    className: "v",
    points: "283.23 171.13 262.48 159.14 262.69 158.26 283.45 170.25 283.23 171.13"
  })), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    className: "v",
    points: "273.92 167.72 262.05 160.86 262.27 159.98 274.14 166.84 273.92 167.72"
  })), _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    className: "v",
    points: "282.76 172.82 274.65 168.14 274.87 167.26 282.97 171.94 282.76 172.82"
  })), _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
    className: "v",
    points: "263.93 163.91 258.88 160.99 259.1 160.11 264.14 163.03 263.93 163.91"
  })), _polygon33 || (_polygon33 = /*#__PURE__*/React.createElement("polygon", {
    className: "v",
    points: "271.38 170.17 258.46 162.71 258.67 161.83 271.59 169.29 271.38 170.17"
  })), _polygon34 || (_polygon34 = /*#__PURE__*/React.createElement("polygon", {
    className: "v",
    points: "281.97 176.27 272.13 170.58 272.35 169.7 282.19 175.39 281.97 176.27"
  })), _polygon35 || (_polygon35 = /*#__PURE__*/React.createElement("polygon", {
    className: "v",
    points: "267.53 169.91 258.03 164.43 258.25 163.55 267.74 169.03 267.53 169.91"
  })), _polygon36 || (_polygon36 = /*#__PURE__*/React.createElement("polygon", {
    className: "v",
    points: "268.99 172.72 257.61 166.15 257.83 165.27 269.2 171.84 268.99 172.72"
  })), _polygon37 || (_polygon37 = /*#__PURE__*/React.createElement("polygon", {
    className: "v",
    points: "272.76 176.99 260.18 169.73 260.4 168.85 272.98 176.11 272.76 176.99"
  })), _polygon38 || (_polygon38 = /*#__PURE__*/React.createElement("polygon", {
    className: "v",
    points: "275.55 180.57 259.76 171.45 259.98 170.57 275.77 179.69 275.55 180.57"
  })), _polygon39 || (_polygon39 = /*#__PURE__*/React.createElement("polygon", {
    className: "v",
    points: "264.38 176.08 259.34 173.17 259.55 172.29 264.6 175.2 264.38 176.08"
  })), _polygon40 || (_polygon40 = /*#__PURE__*/React.createElement("polygon", {
    className: "v",
    points: "278.89 186.4 276.88 185.24 277.1 184.36 279.11 185.52 278.89 186.4"
  })), _polygon41 || (_polygon41 = /*#__PURE__*/React.createElement("polygon", {
    className: "v",
    points: "276.08 184.8 258.91 174.88 259.13 174 276.29 183.92 276.08 184.8"
  })), _polygon42 || (_polygon42 = /*#__PURE__*/React.createElement("polygon", {
    className: "v",
    points: "264.37 180 259.32 177.09 259.54 176.21 264.59 179.12 264.37 180"
  })), _polygon43 || (_polygon43 = /*#__PURE__*/React.createElement("polygon", {
    className: "v",
    points: "277.3 187.47 265.06 180.4 265.28 179.52 277.51 186.59 277.3 187.47"
  })), _polygon44 || (_polygon44 = /*#__PURE__*/React.createElement("polygon", {
    className: "v",
    points: "267.66 183.86 258.07 178.32 258.28 177.44 267.88 182.98 267.66 183.86"
  })), _polygon45 || (_polygon45 = /*#__PURE__*/React.createElement("polygon", {
    className: "v",
    points: "261.12 182.05 256.07 179.13 256.29 178.25 261.33 181.17 261.12 182.05"
  })), _polygon46 || (_polygon46 = /*#__PURE__*/React.createElement("polygon", {
    className: "v",
    points: "256.87 137.15 252.75 134.77 252.54 135.65 256.66 138.03 256.87 137.15"
  })), _polygon47 || (_polygon47 = /*#__PURE__*/React.createElement("polygon", {
    className: "v",
    points: "256.45 138.87 252.33 136.49 252.11 137.37 256.23 139.75 256.45 138.87"
  })), _polygon48 || (_polygon48 = /*#__PURE__*/React.createElement("polygon", {
    className: "v",
    points: "255.6 142.31 249.37 138.7 249.15 139.58 255.39 143.19 255.6 142.31"
  })), _polygon49 || (_polygon49 = /*#__PURE__*/React.createElement("polygon", {
    className: "v",
    points: "248.59 141.87 248.37 142.75 253.25 145.56 253.47 144.69 248.59 141.87"
  })), _polygon50 || (_polygon50 = /*#__PURE__*/React.createElement("polygon", {
    className: "v",
    points: "250.64 133.55 250.42 134.43 251.89 135.27 252.1 134.39 250.64 133.55"
  })), _polygon51 || (_polygon51 = /*#__PURE__*/React.createElement("polygon", {
    className: "v",
    points: "250.22 135.27 250 136.15 251.47 136.99 251.68 136.11 250.22 135.27"
  })), _polygon52 || (_polygon52 = /*#__PURE__*/React.createElement("polygon", {
    className: "v",
    points: "247.23 147.39 247.01 148.27 249.11 149.48 249.33 148.6 247.23 147.39"
  })), _polygon53 || (_polygon53 = /*#__PURE__*/React.createElement("polygon", {
    className: "v",
    points: "246.81 149.11 246.59 149.99 248.69 151.2 248.9 150.32 246.81 149.11"
  })), _polygon54 || (_polygon54 = /*#__PURE__*/React.createElement("polygon", {
    className: "v",
    points: "245.53 154.26 245.32 155.15 250.16 157.94 250.38 157.06 245.53 154.26"
  })), _polygon55 || (_polygon55 = /*#__PURE__*/React.createElement("polygon", {
    className: "v",
    points: "244.69 157.7 244.47 158.58 249.32 161.38 249.53 160.5 244.69 157.7"
  })), _polygon56 || (_polygon56 = /*#__PURE__*/React.createElement("polygon", {
    className: "v",
    points: "244.24 159.53 244.02 160.41 245.84 161.47 246.06 160.59 244.24 159.53"
  })), _polygon57 || (_polygon57 = /*#__PURE__*/React.createElement("polygon", {
    className: "v",
    points: "242.97 164.69 242.75 165.57 244.57 166.62 244.79 165.74 242.97 164.69"
  })), _polygon58 || (_polygon58 = /*#__PURE__*/React.createElement("polygon", {
    className: "v",
    points: "242.12 168.13 241.9 169.01 243.72 170.06 243.94 169.18 242.12 168.13"
  })), _polygon59 || (_polygon59 = /*#__PURE__*/React.createElement("polygon", {
    className: "k",
    points: "290.63 197.05 290.12 198.87 288.82 198.1 289.32 196.28 290.63 197.05"
  })), _polygon60 || (_polygon60 = /*#__PURE__*/React.createElement("polygon", {
    className: "w",
    points: "291.65 193.37 291.15 195.19 289.84 194.42 290.35 192.6 291.65 193.37"
  })), _polygon61 || (_polygon61 = /*#__PURE__*/React.createElement("polygon", {
    className: "w",
    points: "292.68 189.69 292.17 191.51 290.86 190.74 291.37 188.92 292.68 189.69"
  })), _polygon62 || (_polygon62 = /*#__PURE__*/React.createElement("polygon", {
    className: "k",
    points: "293.7 186.01 293.19 187.83 291.89 187.06 292.39 185.24 293.7 186.01"
  })), _polygon63 || (_polygon63 = /*#__PURE__*/React.createElement("polygon", {
    className: "w",
    points: "294.72 182.34 294.22 184.16 292.91 183.39 293.42 181.57 294.72 182.34"
  })), _polygon64 || (_polygon64 = /*#__PURE__*/React.createElement("polygon", {
    className: "w",
    points: "295.75 178.66 295.24 180.48 293.93 179.71 294.44 177.89 295.75 178.66"
  })), _polygon65 || (_polygon65 = /*#__PURE__*/React.createElement("polygon", {
    className: "x",
    points: "292.63 198.23 292.13 200.05 290.82 199.28 291.33 197.46 292.63 198.23"
  })), _polygon66 || (_polygon66 = /*#__PURE__*/React.createElement("polygon", {
    className: "k",
    points: "293.66 194.55 293.15 196.37 291.85 195.6 292.35 193.78 293.66 194.55"
  })), _polygon67 || (_polygon67 = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "294.68 190.87 294.18 192.69 292.87 191.92 293.38 190.1 294.68 190.87"
  })), _polygon68 || (_polygon68 = /*#__PURE__*/React.createElement("polygon", {
    className: "w",
    points: "295.7 187.19 295.2 189.01 293.89 188.25 294.4 186.43 295.7 187.19"
  })), _polygon69 || (_polygon69 = /*#__PURE__*/React.createElement("polygon", {
    className: "w",
    points: "296.73 183.52 296.22 185.34 294.92 184.57 295.42 182.75 296.73 183.52"
  })), _polygon70 || (_polygon70 = /*#__PURE__*/React.createElement("polygon", {
    className: "y",
    points: "297.75 179.84 297.25 181.66 295.94 180.89 296.44 179.07 297.75 179.84"
  })), _polygon71 || (_polygon71 = /*#__PURE__*/React.createElement("polygon", {
    className: "w",
    points: "294.68 199.43 294.17 201.25 292.86 200.48 293.37 198.66 294.68 199.43"
  })), _polygon72 || (_polygon72 = /*#__PURE__*/React.createElement("polygon", {
    className: "w",
    points: "295.7 195.75 295.19 197.57 293.88 196.8 294.39 194.98 295.7 195.75"
  })), _polygon73 || (_polygon73 = /*#__PURE__*/React.createElement("polygon", {
    className: "x",
    points: "296.72 192.07 296.21 193.9 294.91 193.13 295.42 191.31 296.72 192.07"
  })), _polygon74 || (_polygon74 = /*#__PURE__*/React.createElement("polygon", {
    className: "k",
    points: "297.74 188.4 297.24 190.22 295.93 189.45 296.44 187.63 297.74 188.4"
  })), _polygon75 || (_polygon75 = /*#__PURE__*/React.createElement("polygon", {
    className: "w",
    points: "298.77 184.72 298.26 186.54 296.95 185.77 297.46 183.95 298.77 184.72"
  })), _polygon76 || (_polygon76 = /*#__PURE__*/React.createElement("polygon", {
    className: "y",
    points: "299.79 181.04 299.29 182.86 297.98 182.09 298.49 180.27 299.79 181.04"
  })), _polygon77 || (_polygon77 = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "296.57 200.55 296.06 202.37 294.76 201.6 295.26 199.78 296.57 200.55"
  })), _polygon78 || (_polygon78 = /*#__PURE__*/React.createElement("polygon", {
    className: "k",
    points: "297.6 196.87 297.09 198.69 295.78 197.92 296.29 196.1 297.6 196.87"
  })), _polygon79 || (_polygon79 = /*#__PURE__*/React.createElement("polygon", {
    className: "w",
    points: "298.62 193.19 298.11 195.01 296.81 194.24 297.31 192.42 298.62 193.19"
  })), _polygon80 || (_polygon80 = /*#__PURE__*/React.createElement("polygon", {
    className: "w",
    points: "299.64 189.51 299.13 191.34 297.83 190.56 298.33 188.75 299.64 189.51"
  })), _polygon81 || (_polygon81 = /*#__PURE__*/React.createElement("polygon", {
    className: "w",
    points: "300.67 185.84 300.16 187.66 298.85 186.89 299.36 185.07 300.67 185.84"
  })), _polygon82 || (_polygon82 = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "301.69 182.16 301.18 183.98 299.88 183.21 300.38 181.39 301.69 182.16"
  })), _polygon83 || (_polygon83 = /*#__PURE__*/React.createElement("polygon", {
    className: "k",
    points: "296.83 163.65 290.52 159.74 290.32 160.53 296.63 164.43 296.83 163.65"
  })), _polygon84 || (_polygon84 = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "296.12 166.46 289.81 162.55 289.61 163.34 295.92 167.24 296.12 166.46"
  })), _polygon85 || (_polygon85 = /*#__PURE__*/React.createElement("polygon", {
    className: "k",
    points: "291.68 155.16 291.48 155.94 293.69 157.31 293.88 156.53 291.68 155.16"
  })), _polygon86 || (_polygon86 = /*#__PURE__*/React.createElement("polygon", {
    className: "k",
    points: "291.29 156.69 291.09 157.47 293.3 158.84 293.5 158.06 291.29 156.69"
  })), _polygon87 || (_polygon87 = /*#__PURE__*/React.createElement("polygon", {
    className: "k",
    points: "288.57 167.46 288.37 168.24 290.22 169.38 290.42 168.6 288.57 167.46"
  })), _polygon88 || (_polygon88 = /*#__PURE__*/React.createElement("polygon", {
    className: "k",
    points: "288.18 168.99 287.98 169.77 289.83 170.91 290.03 170.13 288.18 168.99"
  })), _polygon89 || (_polygon89 = /*#__PURE__*/React.createElement("polygon", {
    className: "k",
    points: "287.02 173.56 286.82 174.35 291.1 176.99 291.3 176.21 287.02 173.56"
  })), _polygon90 || (_polygon90 = /*#__PURE__*/React.createElement("polygon", {
    className: "k",
    points: "286.25 176.62 286.05 177.4 290.33 180.04 290.52 179.26 286.25 176.62"
  })), _polygon91 || (_polygon91 = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "285.84 178.25 285.64 179.03 287.25 180.02 287.44 179.24 285.84 178.25"
  })), _polygon92 || (_polygon92 = /*#__PURE__*/React.createElement("polygon", {
    className: "k",
    points: "284.68 182.83 284.48 183.61 286.09 184.6 286.29 183.82 284.68 182.83"
  })), _polygon93 || (_polygon93 = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "283.91 185.88 283.71 186.66 285.32 187.66 285.51 186.87 283.91 185.88"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M678.51,372.32c5.65,3.27,14.81,3.28,20.42,0s5.58-8.55-.06-11.82l-.13-.07,4.87-2.81.12.07c8.35,4.83,8.39,12.66.09,17.46S682,380,673.65,375.13l-.12-.07,4.87-2.81Z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M703.82,357.78,699,360.6c-5.62-3.18-14.61-3.2-20.19,0l-5-2.8C682.06,353,695.48,353,703.82,357.78Z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M678.74,360.56l-.1.06c-5.57,3.22-5.57,8.47,0,11.74l-4.86,2.82c-8.23-4.84-8.23-12.62,0-17.4C673.79,357.76,678.74,360.56,678.74,360.56Z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M560.41,379.55l-26.64-15.5a8.46,8.46,0,0,0-8.51,0l-34.12,19.75,30,17.84H534l26.45-16.34A3.35,3.35,0,0,0,560.41,379.55Z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M553,365.49v16.67a2.43,2.43,0,0,1-1.21,2.09l-28.35,16.4a8.35,8.35,0,0,1-8.37,0L486.77,384.3a2.31,2.31,0,0,1-1.16-2.14h-.17V365.49Z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M523.36,383.81l28.35-16.41a2.42,2.42,0,0,0,0-4.18l-28.5-16.49a7.58,7.58,0,0,0-7.62,0l-28.86,16.7a2.34,2.34,0,0,0,0,4L515,383.81A8.35,8.35,0,0,0,523.36,383.81Z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M526.88,388.51a2.37,2.37,0,0,0-1,1.9c0,.73.44,1.07,1,.75l18.28-10.58,0-2.67Z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M547.75,376.43l-2.57,1.48,0,2.67,2.59-1.5a2.39,2.39,0,0,0,1-1.9C548.75,376.45,548.3,376.11,547.75,376.43Z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M553,343.78v16.67a2.43,2.43,0,0,1-1.21,2.09L523.39,379a8.4,8.4,0,0,1-8.37,0l-28.25-16.36a2.31,2.31,0,0,1-1.16-2.14h-.17V343.78Z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M523.36,362.1l28.35-16.41a2.42,2.42,0,0,0,0-4.18L523.21,325a7.58,7.58,0,0,0-7.62,0l-28.86,16.7a2.34,2.34,0,0,0,0,4L515,362.1A8.35,8.35,0,0,0,523.36,362.1Z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M526.88,366.8a2.38,2.38,0,0,0-1,1.9c0,.73.44,1.07,1,.75l18.28-10.58,0-2.66Z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M547.75,354.72l-2.57,1.49,0,2.66,2.59-1.5a2.38,2.38,0,0,0,1-1.9C548.75,354.74,548.3,354.4,547.75,354.72Z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M553,322v16.67a2.42,2.42,0,0,1-1.21,2.09l-28.35,16.41a8.35,8.35,0,0,1-8.37,0l-28.25-16.35a2.33,2.33,0,0,1-1.16-2.15h-.17V322Z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M523.36,340.34l28.35-16.4a2.43,2.43,0,0,0,0-4.19l-28.5-16.49a7.63,7.63,0,0,0-7.62,0L486.73,320a2.34,2.34,0,0,0,0,4L515,340.34A8.35,8.35,0,0,0,523.36,340.34Z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M526.88,345a2.38,2.38,0,0,0-1,1.9c0,.73.44,1.07,1,.76l18.28-10.58,0-2.67Z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M547.75,333l-2.57,1.49,0,2.67,2.59-1.51a2.38,2.38,0,0,0,1-1.9C548.75,333,548.3,332.64,547.75,333Z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M553,300.12v16.66a2.44,2.44,0,0,1-1.21,2.1l-28.35,16.4a8.35,8.35,0,0,1-8.37,0l-28.25-16.35a2.32,2.32,0,0,1-1.16-2.15h-.17V300.12Z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M523.36,318.44,551.71,302a2.42,2.42,0,0,0,0-4.18l-28.5-16.5a7.63,7.63,0,0,0-7.62,0l-28.86,16.71a2.34,2.34,0,0,0,0,4L515,318.44A8.35,8.35,0,0,0,523.36,318.44Z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M526.88,323.14a2.37,2.37,0,0,0-1,1.9c0,.73.44,1.07,1,.75l18.28-10.58,0-2.67Z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M547.75,311.05l-2.57,1.49,0,2.67,2.59-1.5a2.39,2.39,0,0,0,1-1.9C548.75,311.08,548.3,310.74,547.75,311.05Z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M513.64,325.49a2.55,2.55,0,0,0,1.14,2c.64.36,1.15.07,1.15-.66a2.52,2.52,0,0,0-1.15-2C514.15,324.47,513.64,324.77,513.64,325.49Z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M509.6,323.16a2.53,2.53,0,0,0,1.14,2c.64.37,1.15.07,1.15-.65a2.54,2.54,0,0,0-1.15-2C510.11,322.13,509.6,322.43,509.6,323.16Z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M505.56,320.82a2.5,2.5,0,0,0,1.15,2c.63.37,1.14.08,1.14-.65a2.55,2.55,0,0,0-1.14-2C506.07,319.8,505.56,320.09,505.56,320.82Z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M501.52,318.48a2.54,2.54,0,0,0,1.15,2c.63.36,1.14.07,1.14-.66a2.52,2.52,0,0,0-1.14-2C502,317.46,501.52,317.75,501.52,318.48Z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M497.48,316.14a2.54,2.54,0,0,0,1.15,2c.63.37,1.15.07,1.15-.66a2.54,2.54,0,0,0-1.15-2C498,315.12,497.48,315.42,497.48,316.14Z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M493.44,313.81a2.54,2.54,0,0,0,1.15,2c.63.37,1.15.07,1.15-.65a2.56,2.56,0,0,0-1.15-2C494,312.78,493.44,313.08,493.44,313.81Z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M489.4,311.47a2.53,2.53,0,0,0,1.15,2c.63.37,1.15.08,1.15-.65a2.56,2.56,0,0,0-1.15-2C489.92,310.45,489.4,310.74,489.4,311.47Z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M514.23,348.19a2.52,2.52,0,0,0,1.14,2c.64.37,1.15.08,1.15-.65a2.54,2.54,0,0,0-1.15-2C514.74,347.17,514.23,347.46,514.23,348.19Z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M510.19,345.85a2.55,2.55,0,0,0,1.14,2c.64.36,1.15.07,1.15-.66a2.5,2.5,0,0,0-1.15-2C510.7,344.83,510.19,345.12,510.19,345.85Z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M506.15,343.51a2.54,2.54,0,0,0,1.15,2c.63.37,1.14.07,1.14-.66a2.53,2.53,0,0,0-1.14-2C506.66,342.49,506.15,342.79,506.15,343.51Z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M502.11,341.18a2.52,2.52,0,0,0,1.15,2c.63.37,1.14.07,1.14-.65a2.55,2.55,0,0,0-1.14-2C502.62,340.15,502.11,340.45,502.11,341.18Z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M498.07,338.84a2.53,2.53,0,0,0,1.15,2c.63.37,1.15.08,1.15-.65a2.56,2.56,0,0,0-1.15-2C498.59,337.82,498.07,338.11,498.07,338.84Z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M494,336.5a2.56,2.56,0,0,0,1.15,2c.63.36,1.15.07,1.15-.66a2.53,2.53,0,0,0-1.15-2C494.55,335.48,494,335.77,494,336.5Z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M490,334.16a2.56,2.56,0,0,0,1.15,2c.63.37,1.15.07,1.15-.66a2.54,2.54,0,0,0-1.15-2C490.51,333.14,490,333.44,490,334.16Z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M513.34,370.06a2.5,2.5,0,0,0,1.15,2c.63.37,1.14.08,1.14-.65a2.55,2.55,0,0,0-1.14-2C513.85,369,513.34,369.33,513.34,370.06Z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M509.3,367.72a2.5,2.5,0,0,0,1.15,2c.63.37,1.15.08,1.15-.65a2.53,2.53,0,0,0-1.15-2C509.81,366.7,509.3,367,509.3,367.72Z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M505.26,365.38a2.56,2.56,0,0,0,1.15,2c.63.36,1.15.07,1.15-.66a2.53,2.53,0,0,0-1.15-2C505.78,364.36,505.26,364.65,505.26,365.38Z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M501.22,363.05a2.56,2.56,0,0,0,1.15,2c.63.37,1.15.07,1.15-.66a2.54,2.54,0,0,0-1.15-2C501.74,362,501.22,362.32,501.22,363.05Z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M497.19,360.71a2.52,2.52,0,0,0,1.14,2c.64.37,1.15.08,1.15-.65a2.54,2.54,0,0,0-1.15-2C497.7,359.69,497.19,360,497.19,360.71Z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M493.15,358.37a2.52,2.52,0,0,0,1.14,2c.64.37,1.15.08,1.15-.65a2.5,2.5,0,0,0-1.15-2C493.66,357.35,493.15,357.64,493.15,358.37Z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M489.11,356a2.54,2.54,0,0,0,1.15,2c.63.36,1.14.07,1.14-.66a2.52,2.52,0,0,0-1.14-2C489.62,355,489.11,355.3,489.11,356Z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M513,390.48a2.56,2.56,0,0,0,1.15,2c.64.36,1.15.07,1.15-.66a2.5,2.5,0,0,0-1.15-2C513.56,389.46,513,389.75,513,390.48Z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M509,388.15a2.53,2.53,0,0,0,1.14,2c.64.37,1.15.07,1.15-.66a2.53,2.53,0,0,0-1.15-2C509.52,387.12,509,387.42,509,388.15Z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M505,385.81a2.52,2.52,0,0,0,1.14,2c.64.37,1.15.08,1.15-.65a2.54,2.54,0,0,0-1.15-2C505.48,384.79,505,385.08,505,385.81Z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M500.93,383.47a2.54,2.54,0,0,0,1.15,2c.63.36,1.14.07,1.14-.66a2.52,2.52,0,0,0-1.14-2C501.44,382.45,500.93,382.74,500.93,383.47Z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M496.89,381.13a2.54,2.54,0,0,0,1.15,2c.63.36,1.14.07,1.14-.66a2.53,2.53,0,0,0-1.14-2C497.4,380.11,496.89,380.41,496.89,381.13Z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M492.85,378.8a2.54,2.54,0,0,0,1.15,2c.63.37,1.15.07,1.15-.66a2.56,2.56,0,0,0-1.15-2C493.37,377.77,492.85,378.07,492.85,378.8Z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M488.81,376.46a2.53,2.53,0,0,0,1.15,2c.63.37,1.15.08,1.15-.65a2.56,2.56,0,0,0-1.15-2C489.33,375.44,488.81,375.73,488.81,376.46Z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M96.45,357.41a8.42,8.42,0,0,1-3.89-1l-68.2-35.77A.8.8,0,0,1,24,319.6a.78.78,0,0,1,1.07-.33L93.29,355a6.8,6.8,0,0,0,6.56-.13l246.7-140.2a1.32,1.32,0,0,0,.66-1.15,1.29,1.29,0,0,0-.65-1.15l-10-5.9a5.08,5.08,0,0,1-2.51-4.38V180.29a5.47,5.47,0,0,1,2.68-4.69l10.37-6.06a.79.79,0,0,1,.8,1.37L337.5,177a3.86,3.86,0,0,0-1.89,3.32v21.84a3.5,3.5,0,0,0,1.72,3l10,5.89a2.92,2.92,0,0,1,0,5.05L100.64,356.28A8.37,8.37,0,0,1,96.45,357.41Z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M316.06,346a2,2,0,0,1-1-.28,2.07,2.07,0,0,1-1-1.8v-4.15a3.21,3.21,0,0,0-1.73-2.86l-15.42-8,.73-1.4,15.42,8a4.79,4.79,0,0,1,2.59,4.27v4.15a.5.5,0,0,0,.24.43.48.48,0,0,0,.49,0l125-71.86a5.91,5.91,0,0,0,3-5.12v-14a8.48,8.48,0,0,1,4-7.19l5.85-3.59.83,1.36-5.85,3.58a6.87,6.87,0,0,0-3.27,5.84v14a7.51,7.51,0,0,1-3.75,6.5l-125,71.85A2,2,0,0,1,316.06,346Z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M572.47,403.72a6.79,6.79,0,0,1-3.3-.85L536.94,385a.8.8,0,0,1-.31-1.08.78.78,0,0,1,1.07-.31l32.24,17.84a5.22,5.22,0,0,0,5.3-.14l49.49-30.89a1.52,1.52,0,0,0,.73-1.36,1.55,1.55,0,0,0-.81-1.32l-28.3-15.47a6.54,6.54,0,0,1-3.39-5.74v-23a5.62,5.62,0,0,1,2.61-4.77l9.35-6a.81.81,0,0,1,1.1.25.79.79,0,0,1-.25,1.09l-9.35,6a4,4,0,0,0-1.88,3.43v23a5,5,0,0,0,2.57,4.35l28.3,15.47a3.15,3.15,0,0,1,.16,5.42l-49.49,30.89A6.82,6.82,0,0,1,572.47,403.72Z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M385.17,268.12a.61.61,0,0,1-.56,0,.17.17,0,0,1,0-.32.61.61,0,0,1,.56,0C385.33,267.89,385.33,268,385.17,268.12Z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M386.62,269a.59.59,0,0,1-.55,0,.18.18,0,0,1,0-.33.61.61,0,0,1,.56,0A.17.17,0,0,1,386.62,269Z"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M388.08,269.81a.61.61,0,0,1-.56,0c-.16-.09-.16-.23,0-.32a.61.61,0,0,1,.56,0A.17.17,0,0,1,388.08,269.81Z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M389.53,270.66a.65.65,0,0,1-.56,0,.17.17,0,0,1,0-.32.61.61,0,0,1,.56,0A.18.18,0,0,1,389.53,270.66Z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M391,271.5a.61.61,0,0,1-.56,0,.18.18,0,0,1,0-.33.61.61,0,0,1,.56,0C391.14,271.27,391.14,271.41,391,271.5Z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M392.44,272.34a.61.61,0,0,1-.56,0c-.16-.09-.16-.23,0-.32a.59.59,0,0,1,.55,0C392.59,272.11,392.59,272.25,392.44,272.34Z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M393.89,273.19a.61.61,0,0,1-.56,0c-.16-.09-.16-.23,0-.32a.61.61,0,0,1,.56,0A.18.18,0,0,1,393.89,273.19Z"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M395.34,274a.61.61,0,0,1-.56,0,.18.18,0,0,1,0-.33.65.65,0,0,1,.56,0A.17.17,0,0,1,395.34,274Z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M396.79,274.87a.61.61,0,0,1-.56,0,.17.17,0,0,1,0-.32.61.61,0,0,1,.56,0C397,274.64,397,274.78,396.79,274.87Z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M398.25,275.72a.61.61,0,0,1-.56,0,.17.17,0,0,1,0-.33.59.59,0,0,1,.55,0A.18.18,0,0,1,398.25,275.72Z"
  })), _polygon94 || (_polygon94 = /*#__PURE__*/React.createElement("polygon", {
    className: "v",
    points: "393.48 263.65 388.04 266.79 387.34 266.38 392.77 263.24 393.48 263.65"
  })), _polygon95 || (_polygon95 = /*#__PURE__*/React.createElement("polygon", {
    className: "v",
    points: "394.84 264.44 389.41 267.58 388.7 267.17 394.14 264.04 394.84 264.44"
  })), _polygon96 || (_polygon96 = /*#__PURE__*/React.createElement("polygon", {
    className: "v",
    points: "396.21 265.24 390.77 268.38 390.07 267.97 395.51 264.83 396.21 265.24"
  })), _polygon97 || (_polygon97 = /*#__PURE__*/React.createElement("polygon", {
    className: "v",
    points: "402 263.49 392.14 269.17 391.44 268.76 401.3 263.08 402 263.49"
  })), _polygon98 || (_polygon98 = /*#__PURE__*/React.createElement("polygon", {
    className: "v",
    points: "402.56 266.08 397.13 269.21 396.43 268.81 401.86 265.67 402.56 266.08"
  })), _polygon99 || (_polygon99 = /*#__PURE__*/React.createElement("polygon", {
    className: "v",
    points: "403.93 266.87 398.49 270.01 397.79 269.6 403.23 266.46 403.93 266.87"
  })), _polygon100 || (_polygon100 = /*#__PURE__*/React.createElement("polygon", {
    className: "v",
    points: "405.3 267.67 399.86 270.8 399.16 270.4 404.6 267.26 405.3 267.67"
  })), _polygon101 || (_polygon101 = /*#__PURE__*/React.createElement("polygon", {
    className: "v",
    points: "404.57 256.44 393.47 262.84 394.17 263.25 405.28 256.84 404.57 256.44"
  })), _polygon102 || (_polygon102 = /*#__PURE__*/React.createElement("polygon", {
    className: "v",
    points: "405.85 258.1 395.54 264.04 394.84 263.63 405.14 257.69 405.85 258.1"
  })), _polygon103 || (_polygon103 = /*#__PURE__*/React.createElement("polygon", {
    className: "v",
    points: "407.32 258.02 396.21 264.43 396.91 264.84 408.03 258.42 407.32 258.02"
  })), _polygon104 || (_polygon104 = /*#__PURE__*/React.createElement("polygon", {
    className: "v",
    points: "408.7 258.81 403.13 262.02 403.83 262.43 409.4 259.21 408.7 258.81"
  })), _polygon105 || (_polygon105 = /*#__PURE__*/React.createElement("polygon", {
    className: "v",
    points: "411.23 260.27 402.56 265.27 403.26 265.67 411.94 260.67 411.23 260.27"
  })), _polygon106 || (_polygon106 = /*#__PURE__*/React.createElement("polygon", {
    className: "v",
    points: "412.61 261.06 403.93 266.06 404.63 266.47 413.31 261.46 412.61 261.06"
  })), _polygon107 || (_polygon107 = /*#__PURE__*/React.createElement("polygon", {
    className: "v",
    points: "413.98 261.85 405.3 266.86 406 267.26 414.69 262.25 413.98 261.85"
  })), _polygon108 || (_polygon108 = /*#__PURE__*/React.createElement("polygon", {
    className: "v",
    points: "409.95 266.9 404.52 270.04 403.81 269.63 409.25 266.5 409.95 266.9"
  })), _polygon109 || (_polygon109 = /*#__PURE__*/React.createElement("polygon", {
    className: "v",
    points: "415.64 262.8 409.96 266.08 410.66 266.49 416.35 263.21 415.64 262.8"
  })), _polygon110 || (_polygon110 = /*#__PURE__*/React.createElement("polygon", {
    className: "v",
    points: "417.02 263.6 405.18 270.43 405.88 270.84 417.73 264 417.02 263.6"
  })), _polygon111 || (_polygon111 = /*#__PURE__*/React.createElement("polygon", {
    className: "v",
    points: "418.4 264.39 406.55 271.22 407.25 271.63 419.1 264.8 418.4 264.39"
  })), _polygon112 || (_polygon112 = /*#__PURE__*/React.createElement("polygon", {
    className: "v",
    points: "382.41 269.24 377.97 271.8 378.67 272.2 383.11 269.64 382.41 269.24"
  })), _polygon113 || (_polygon113 = /*#__PURE__*/React.createElement("polygon", {
    className: "v",
    points: "383.78 270.03 379.34 272.59 380.04 273 384.48 270.44 383.78 270.03"
  })), _polygon114 || (_polygon114 = /*#__PURE__*/React.createElement("polygon", {
    className: "v",
    points: "386.52 271.62 379.8 275.5 380.5 275.9 387.22 272.03 386.52 271.62"
  })), _polygon115 || (_polygon115 = /*#__PURE__*/React.createElement("polygon", {
    className: "v",
    points: "382.32 276.96 383.02 277.37 388.28 274.34 387.58 273.93 382.32 276.96"
  })), _polygon116 || (_polygon116 = /*#__PURE__*/React.createElement("polygon", {
    className: "v",
    points: "375.69 273.11 376.4 273.52 377.98 272.61 377.27 272.2 375.69 273.11"
  })), _polygon117 || (_polygon117 = /*#__PURE__*/React.createElement("polygon", {
    className: "v",
    points: "377.06 273.91 377.76 274.31 379.35 273.4 378.64 273 377.06 273.91"
  })), _polygon118 || (_polygon118 = /*#__PURE__*/React.createElement("polygon", {
    className: "v",
    points: "386.72 279.51 387.42 279.92 389.68 278.62 388.98 278.21 386.72 279.51"
  })), _polygon119 || (_polygon119 = /*#__PURE__*/React.createElement("polygon", {
    className: "v",
    points: "388.09 280.31 388.79 280.72 391.05 279.41 390.35 279 388.09 280.31"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.bf5dc6a6081339663847c9eeab45e8cb.svg";
export { ForwardRef as ReactComponent };